import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { NotifierService } from "angular-notifier";
import { ActivatedRoute } from '@angular/router';
import { PostStripeService } from '../../services/post-stripe.service';
import { MixPanelService } from '../../services/mix-panel.service';
import { Subscription } from 'rxjs';
import { loadStripe } from '@stripe/stripe-js/pure';
import { GetRecordLandingService } from '../../services/get-record-landing.service';
import { environment } from 'src/environments/environment';
import { EnvironmentService } from 'src/app/services/environment.service';

@Component({
  selector: 'app-retry',
  templateUrl: './retry.component.html',
  styleUrls: ['./retry.component.css'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { showError: false },
    },
  ]
})

export class RetryComponent implements OnInit {
  _env: string = this.env._env;
  fieldTextType: boolean = false;
  public firstFormGroup: FormGroup = new FormGroup({
  })
  public secondFormGroup: FormGroup = new FormGroup({
  })
  public signupForm: FormGroup = new FormGroup({
  })
  check_company: Promise<any> = null;
  checkCompany: Promise<any> = null;
  stepOneCompleted: boolean = true;
  stepTwoCompleted: boolean = false;
  stepThreeCompleted: boolean = false;
  titleLastStep: string = "Falta poco";
  textLastStep: string = "Procesando...";
  textSubtitleLastStep: string = "";
  textUser: string = "";
  textPaymentAmount = "";
  url_path: string = window.location.href;
  textLSMainMessage = "";
  LSCobrado = false;
  LSError = false;
  textLSUserName = ""
  textLSOnBoardingAgent = ""
  textLSOnBoardingEmail = ""
  textLSOnBoardingPhone = ""
  isMobile: any = false;
  isRetry: any = false;
  plan_name: Promise<any> = null;
  bp_name: Promise<any> = null;
  order_total: Promise<any> = null;
  elements: any;
  stripe: any;
  stripe_api_key: string;
  stripe_secret_key: string;
  client_secret: string;
  private routeSub: Subscription;
  recordLanding: Promise<any> = null;

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  private readonly notifier: NotifierService;

  constructor(
    notifierService: NotifierService,
    private activatedRoute: ActivatedRoute,
    public PostStripe: PostStripeService,
    private mixpanelService: MixPanelService,
    public GetRecordLanding: GetRecordLandingService,
    private env: EnvironmentService
  ) {
    this.notifier = notifierService;
  }

  async ngOnInit() {
    this.addMixPanelEvent('LandingRetryCard', { status: 'ok' });
    this.mobileCheck();
    this.activatedRoute.queryParams.subscribe(async params => {
      this.stripe_api_key = environment[this._env]['STRIP_API_KEY_LIVE'];

      this.client_secret = params['setup_intent_client'] || params['stripe_clientsecret_id'] || params['setup_intent_client_secret']
      this.recordLanding = await this.getRecordLandingData();
      console.log("RL:", this.recordLanding);
      this.order_total = this.recordLanding["record_landing"]["total"];
      this.bp_name = this.recordLanding["record_landing"]["name"];
      this.plan_name = this.recordLanding["record_landing"]["plan_name"];
      this.stripe = loadStripe(this.stripe_api_key);
      const options = {
        clientSecret: this.client_secret //'{{CLIENT_SECRET}}'
      };
      console.log("stripe_", this.stripe);
      console.log("options:", options);
      this.elements = (await this.stripe).elements(options);
      const paymentElement = this.elements.create('payment');
      paymentElement.mount('#payment-element');
      const form = document.getElementById('payment-form');
      //https://signup.contalink.com/listo
      //
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const errorStripe = (await this.stripe).confirmSetup({
          elements: this.elements,
          confirmParams: {
            return_url: `${environment[this._env]['url']}/listoss`
          }
        }).then((data) => {
          console.log("stripe response: " + JSON.stringify(data));
          if (data.hasOwnProperty("error")) {
            if (data.error.hasOwnProperty("message")) {
              let errorMessagePopUp = JSON.stringify(data.error.message);
              alert(errorMessagePopUp);
            }
          }
        });
        if (errorStripe) {
          console.log("ES0", errorStripe)
          const messageContainer = document.querySelector('#error-message');
        } else {
          // Your customer will be redirected to your `return_url`. For some payment
          // methods like iDEAL, your customer will be redirected to an intermediate
          // site first to authorize the payment, then redirected to the `return_url`.
        }
      });
      let load_div = document.getElementById("loading-retry-section") as HTMLElement;
      let payment_section = document.getElementById("card-retry-section") as HTMLElement;
      load_div.style.display = "none";
      payment_section.style.display = "block";
    });
  }

  ngOnDestroy() {
    this.routeSub.unsubscribe();
  }
  addMixPanelEvent(action, params) {
    this.mixpanelService.track(
      action,
      params,
      this.url_path
    );
  }

  private mobileCheck() {
    let check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent);
    this.isMobile = check;
  }

  async getRecordLandingData() {
    return await this.GetRecordLanding.getContalinkRecordLanding({
      record_landing_id: this.client_secret
    }).toPromise();
  }
}